import {
  FETCH_USER_DATA_BEGIN,
  FETCH_USER_DATA_SUCCESS,
  FETCH_USER_DATA_FAILURE,
  SET_AUTH_STATUS,
  SET_USER_LOGOUT,
} from "../actionTypes/userDataActionTypes";

const defaultState = {
  userData: null,
  userDataIsLoading: false,
  userDataError: "",
  isAuth: false,
};

export default function userDataReducer(state = defaultState, action) {
  switch (action.type) {
    case SET_AUTH_STATUS:
      return {
        ...state,
        isAuth: action.payload,
      };
    case SET_USER_LOGOUT:
      return {
        ...state,
        userData: null,
      };
    case FETCH_USER_DATA_BEGIN:
      return {
        ...state,
        userDataIsLoading: true,
      };
    case FETCH_USER_DATA_SUCCESS:
      return {
        ...state,
        userDataIsLoading: false,
        userData: action.data,
      };
    case FETCH_USER_DATA_FAILURE:
      return {
        ...state,
        userDataIsLoading: false,
        userDataError: action.error,
        userData: null,
      };

    default:
      return state;
  }
}
